export default __webpack_public_path__ + "static/media/earn-icon.ffa07b8a.svg";